import portfolioData from "../data/portfolio.json";
import { motion } from "framer-motion";

const Skills = () => {
  const { technical_stack } = portfolioData;

  const SkillPill = ({ name, delayIndex }) => (
    <motion.span
      animate={{ y: [0, -5, 0] }}
      transition={{ duration: 3, repeat: Infinity, ease: "easeInOut", delay: delayIndex * 0.1 }}
      whileHover={{ scale: 1.1, backgroundColor: "#E7E5E4", color: "#1C1917" }}
      className="px-6 py-3 rounded-full bg-white dark:bg-stone-800 text-stone-700 dark:text-stone-300 font-medium text-sm md:text-base border border-stone-200/80 dark:border-stone-700/80 shadow-sm cursor-default flex items-center justify-center transition-colors"
    >
      {name}
    </motion.span>
  );

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { staggerChildren: 0.1 } }
  };

  return (
    <div id="skills" className="w-full pt-10">
      <motion.h2
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="mb-12 text-center text-4xl font-light text-stone-800 dark:text-stone-200"
      >
        Skills & Tools
      </motion.h2>
      <div className="max-w-5xl mx-auto space-y-16">

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{ once: true }}>
          <h3 className="text-xl font-medium text-stone-500 dark:text-stone-400 mb-6 text-center uppercase tracking-widest text-sm">Languages</h3>
          <div className="flex flex-wrap justify-center gap-4">
            {technical_stack.languages.map((skill, index) => (
              <SkillPill key={index} name={skill} delayIndex={index} />
            ))}
          </div>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{ once: true }}>
          <h3 className="text-xl font-medium text-stone-500 dark:text-stone-400 mb-6 text-center uppercase tracking-widest text-sm">Frontend & Mobile</h3>
          <div className="flex flex-wrap justify-center gap-4">
            {technical_stack.frontend_mobile.map((skill, index) => (
              <SkillPill key={index} name={skill} delayIndex={index} />
            ))}
          </div>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{ once: true }}>
          <h3 className="text-xl font-medium text-stone-500 dark:text-stone-400 mb-6 text-center uppercase tracking-widest text-sm">Backend & Frameworks</h3>
          <div className="flex flex-wrap justify-center gap-4">
            {technical_stack.backend_and_framework.map((skill, index) => (
              <SkillPill key={index} name={skill} delayIndex={index} />
            ))}
          </div>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{ once: true }}>
          <h3 className="text-xl font-medium text-stone-500 dark:text-stone-400 mb-6 text-center uppercase tracking-widest text-sm">Tools & Platforms</h3>
          <div className="flex flex-wrap justify-center gap-4">
            {technical_stack.tools.map((skill, index) => (
              <SkillPill key={index} name={skill} delayIndex={index} />
            ))}
          </div>
        </motion.div>

      </div>
    </div>
  );
};

export default Skills;
